<script lang="ts" setup>
  import { BaseButton } from '@bt/design-system'
  import type { InvestorEvent } from '@/types/Storyblok/General/EventCard'

  interface IPastEvent extends InvestorEvent {
    uuid: string
  }
  const props = defineProps<{
    blok: {
      title: string
      events: IPastEvent[]
      buttonUrl: { story: { full_slug: string } }
      buttonTitle: string
      buttonTarget: string
    }
  }>()

  const { locale } = useI18n()
  const pageUrl = computed(() => formatSbPath(props.blok?.buttonUrl?.story?.full_slug, locale.value))

  const events = computed(() =>
    props.blok.events.map((event) => ({
      text: event.content.cardText ?? '',
      subText: event.content.cardSubText ?? '',
      type: event.content.eventType ?? '',
      hasVideoRecording: event.content.hasVideoRecording,
      slug: event.slug
    }))
  )

  const router = useRouter()
  const openEvent = (slug: string) => pageUrl.value && router.push({ path: pageUrl.value, query: { event: slug } })
  const openAllEventsPage = () => router.push({ path: pageUrl.value })
</script>

<template>
  <div class="mb-6 lg:mb-10">
    <div class="block-title">
      <h2 class="text-bt-blue-dark text-h2">{{ blok.title }}</h2>
    </div>
    <div class="flex flex-col gap-8 lg:gap-10">
      <div class="flex flex-col gap-6 rounded-2xl bg-grey px-4 py-6 lg:flex-row lg:!px-8 lg:!py-10">
        <EventCard
          v-for="event in events"
          :key="event.slug"
          :card-text="event.text"
          :card-sub-text="event.subText"
          :event-type="event.type"
          :has-video-recording="event.hasVideoRecording"
          @click="openEvent(event.slug)"
        />
      </div>
      <div
        v-if="pageUrl"
        class="flex w-full justify-center"
      >
        <BaseButton
          type="outlined"
          block-type="full-on-mobile"
          :title="blok.buttonTitle"
          @click="openAllEventsPage"
        />
      </div>
    </div>
  </div>
</template>
